"use strict";

import {
  EmailAuthProvider,
  deleteUser,
  onAuthStateChanged,
  reauthenticateWithCredential,
} from "firebase/auth";
import {
  initFooter,
  initLangAction,
  initLangCookie,
  setDisplay,
  shake,
  showToast,
} from "./common";
import { db, initAuth } from "./config";
import { onValue, ref } from "firebase/database";
import phUser from "url:../images/user.svg";
let lang;
let ivUser;
let spAcc;
let btnContinue,
  btnCancelLogin,
  btnVerifyAcc,
  btnCancelVerify,
  btnDeleteAcc,
  btnCancelDelete,
  btnErrorOK,
  btnOkSuccess;
let pMsg;
let modLogin,
  modPwVerify,
  modDeleteAcc,
  modDeletingAcc,
  modError,
  modSuccess,
  modLoader;
let inPw;
let user;
let recentLogin;
let auth;

$(document).ready(function () {
  $(function () {
    initFooter();
    lang = initLangCookie();
    initLangAction();
    initUi();
    getUser();
  });
});

function initUi() {
  if (window.location.search.includes("action=success")) {
    recentLogin = true;
  }
  ivUser = document.getElementById("ivUser");
  spAcc = document.getElementById("spAcc");
  btnContinue = document.getElementById("btnContinue");
  modLogin = document.getElementById("modLogin");
  btnCancelLogin = document.getElementById("btnCancel");
  modPwVerify = document.getElementById("modPwVerify");
  inPw = document.getElementById("inPw");
  btnVerifyAcc = modPwVerify.querySelector(".btnVerify");
  btnCancelVerify = modPwVerify.querySelector(".btnCancel");
  modDeleteAcc = document.getElementById("modDeleteAcc");
  btnDeleteAcc = document.getElementById("btnDeleteAcc");
  btnCancelDelete = modDeleteAcc.querySelector(".btnCancel");
  modDeletingAcc = document.getElementById("modDeletingAcc");
  modError = document.getElementById("modError");
  pMsg = document.getElementById("pMsg");
  btnErrorOK = document.getElementById("btnOk");
  modSuccess = document.getElementById("modSuccess");
  btnOkSuccess = document.getElementById("btnOkSuccess");
  modLoader = document.getElementById("modLoader");
}

function getUser() {
  auth = initAuth;
  let startLs = true;
  onAuthStateChanged(auth, (data) => {
    user = data;
    if (startLs) {
      startLs = false;
      initLs();
    }
    if (user) {
      getUserInfo();
    }
  });
}

function getUserInfo() {
  spAcc.textContent = user.email;
  let dbUser = ref(db, `user/${user.uid}`);
  onValue(
    dbUser,
    (data) => {
      if (data.exists()) {
        let info = data.val();
        ivUser.src = info.imgUrl ? info.imgUrl : phUser;
      }
    },
    { onlyOnce: true }
  );
}

function initLs() {
  $(ivUser).on("error", function () {
    ivUser.src = phUser;
  });

  $(btnContinue).click(function () {
    if (recentLogin) {
      setDisplay(modDeleteAcc, "flex");
    } else if (user) {
      setDisplay(modPwVerify, "flex");
    } else {
      setDisplay(modLogin, "flex");
    }
  });

  $(btnCancelLogin).click(function () {
    setDisplay(modLogin, "none");
  });

  $(btnVerifyAcc).click(function () {
    verifyEmail();
  });

  $(btnCancelVerify).click(function () {
    setDisplay(modPwVerify, "none");
  });

  $(btnErrorOK).click(function () {
    setDisplay(modError, "none");
  });

  $(btnDeleteAcc).click(function () {
    setDisplay(modDeleteAcc, "none");
    deleteAccount();
  });

  $(btnCancelDelete).click(function () {
    setDisplay(modDeleteAcc, "none");
  });

  $(btnOkSuccess).click(function () {
    window.location.replace("../login.html");
  });
}
function deleteAccount() {
  setDisplay(modDeletingAcc, "flex");
  deleteUser(user)
    .then(() => {
      setDisplay(modSuccess, "flex");
      setDisplay(modDeletingAcc, "none");
    })
    .catch((e) => {
      recentLogin = false;
      pMsg.textContent = "Could not delete account";
      setDisplay(modError, "flex");
      setDisplay(modDeletingAcc, "none");
    });
}
function verifyEmail() {
  let pw = inPw.value.trim();
  if (pw) {
    inPw.value = "";
    setDisplay(modPwVerify, "none");
    setDisplay(modLoader, "flex");
    let cred = EmailAuthProvider.credential(user.email, pw);
    reauthenticateWithCredential(user, cred)
      .then(() => {
        recentLogin = true;
        setDisplay(modDeleteAcc, "flex");
        setDisplay(modLoader, "none");
      })
      .catch((e) => {
        pMsg.textContent = "Could not authenticate your account";
        setDisplay(modError, "flex");
        setDisplay(modLoader, "none");
      });
  } else {
    shake(inPw);
    showToast("error", "Password cannot be empty");
  }
}
